import { jsx as _jsx } from "react/jsx-runtime";
import { Box } from "native-base";
import { useTranslation } from "@madmedical/i18n";
import { usePreOp } from "../../providers/preop";
import Alert from "../../molecules/Alert";
import { useRouteNavigate } from "../../providers/routing";
import { useCurrentPatient } from "../../providers/currentPatient";
const PreOpAlert = () => {
    var _a;
    const { questionnaire } = usePreOp();
    const navigate = useRouteNavigate();
    const { t } = useTranslation();
    const { patient } = useCurrentPatient();
    const services = ((_a = patient === null || patient === void 0 ? void 0 : patient.services) !== null && _a !== void 0 ? _a : []);
    if (questionnaire) {
        // Already completed
        return null;
    }
    if (patient && !services.includes("pre_post_op")) {
        return null;
    }
    return (_jsx(Box, Object.assign({ mb: 3 }, { children: _jsx(Alert, { title: t("dashboard:preopFill"), description: t("dashboard:preopDescription"), links: [
                {
                    text: t("fill"),
                    onPress: () => {
                        navigate("preop", {});
                    },
                },
            ] }) })));
};
export default PreOpAlert;
